import event from './event';
import $ from 'jquery';
import {REQUEST_CODE, REQUEST_CODE_STR} from './const';
import localStorage from './localStorage';
import envConfig from './config';

var defaultConfig = {
    prefix: "",
    withHeaderToken: true,
    withParamToken:true,
    headerTokenKey: envConfig.headerTokenKey,
    headerTokenPrefix:envConfig.headerTokenPrefix,
    localStorageTokenKey: envConfig.tokenLocalStorageKey,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
    timeout:30*1000,
    toastError: true,
    onUploadProgress:()=>{},
    onAjax:()=>{},
    forceLogin: true,
    processData: true,
    returnOriginalObject:false,
    processResponse: true,
    contentType: true,
    json: false
};
function getOptions(options1, options2) {
    return Object.assign({}, defaultConfig, options1 || {}, options2 || {});
}

class Http {
    constructor(options) {
        this.options = getOptions(options);
    }

    clone(options) {
        return new Http(getOptions(this.options, options));
    }

    get(url, data, config) {
        return this._requestGenerator('GET', url, data, config);
    }

    post(url, data, config) {
        return this._requestGenerator('POST', url, data, config);
    }

    put(url, data, config) {
        return this._requestGenerator('PUT', url, data, config);
    }

    delete(url, data, config) {
        return this._requestGenerator('DELETE', url, data, config);
    }

    _requestGenerator(method, url, data, config) {
        config = $.extend($.extend({}, this.options), config || {});
        return new Promise((resolve, reject) => {
            var token = localStorage.get(config.localStorageTokenKey);
            var o = {
                type: method,
                url: this._getUrl(url, config),
                data: data,
                xhr:function () {
                    var xhr = $.ajaxSettings.xhr();
                    if(xhr.upload){
                        xhr.upload.addEventListener('progress',(e)=>{
                            var percent = (Number(e.loaded / e.total)*100).toFixed(1);
                            config.onUploadProgress(percent);
                        },false);
                    }
                    return xhr;
                },
                headers: $.extend(config.headers, (config.withHeaderToken && token) ? {
                    [config.headerTokenKey]: (config.headerTokenPrefix || '' ) + token
                } : {}),
                processData: config.processData,
                success: resolve,
                error: reject
            };
            if(o.data && config.processData && config.withParamToken){
                o.data.session = token;
            }
            if (method === "POST" && config.json && config.processData) {
                o.data = JSON.stringify(o.data);
                o.contentType = "application/json; charset=utf-8";
                o.dataType = 'json';
            }
            if (config.contentType !== true) {
                o.contentType = config.contentType;
            }
            var req = $.ajax(o);
            if(config.timeout>0){
                setTimeout(()=>{
                    reject({
                        code:REQUEST_CODE.CODE_TIMEOUT,
                        msg:'请求超时'
                    });
                    req.abort();
                },config.timeout);
            }
            config.onAjax(req);
        }).then(function (a) {
            /* res parser
             * 都转化为：
             * code
             * msg
             * data
             * */
            try {
                a = JSON.parse(a);
            } catch (e) {
            }
            if (typeof a.code == 'undefined') {
                return {
                    code: REQUEST_CODE.CODE_SUCCESS,
                    msg: "",
                    data: a
                };
            }

            if (!a.msg) {
                a.msg = a.bmsg || REQUEST_CODE_STR[a.code] || "";
            }

            return a;
        }, function (res) { // catch error
            console.log(res)
            if(res.code && res.msg){
                return res;
            }
            var content = res.responseText;
            try {
                content = JSON.parse(content);
            } catch (e) {
            }

            var errorMsg = "未知错误";
            if (content) {
                errorMsg = content.msg || content.errorMsg || content.error_description || content.error_msg || content.error || errorMsg;
            } else {
                errorMsg = res.statusText || res || errorMsg;
            }
            return {
                code: res.status == 200 ? REQUEST_CODE.CODE_SUCCESS : res.status,
                msg: errorMsg,
                data: content || null
            };
        }).then((a) => {
            // res handler
            if (!config.processResponse) {
                return a;
            }
            return this._errorHandler(a, url, config);
        });
    }

    _errorHandler(a, url, config) {
        config = getOptions(this.options || {}, config);
        if (a.code !== REQUEST_CODE.CODE_SUCCESS) { // some error
            console.error(a);
            if (
                [302, 301, 401, REQUEST_CODE.CODE_UNAUTHORIZED].indexOf(a.code) == -1  // exclude normal status
            ) {
                config.toastError && event.emit('toast', (url || '') + "\n" + a.code + ' ' + (a.msg || a.data && a.data.desc));
                console && console.error(url, a.code + " " + (a.msg|| a.data && a.data.desc));
            }

            if (
                config.forceLogin
                && (a.code == 401 || a.code == REQUEST_CODE.CODE_UNAUTHORIZED)
            ) {
                event.emit('force_logout');
            }

            return Promise.reject(a);
        } else{
            return config.returnOriginalObject ? a : a.data;
        }
    }

    _getUrl(url, config) {
        config = getOptions(this.options || {}, config);
        return config.prefix + url;
    }
}

export default Http;


// WEBPACK FOOTER //
// src/lib/Http.js